import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useAuthStore } from '@/stores/auth.store';

interface LoginConfirmRequest {
  token: string;
  code: string;
}

interface LoginConfirmResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  redirect_to?: string;
}

export function useLoginConfirm() {
  const queryClient = useQueryClient();
  const setTokens = useAuthStore((state) => state.setTokens);

  return useMutation({
    mutationFn: async (data: LoginConfirmRequest) => {
      const response = await api
        .post('auth/login/confirm', { json: data })
        .json<LoginConfirmResponse>();
      return response;
    },
    onSuccess: (data) => {
      setTokens(data.access_token, data.refresh_token);
      // Invalidate user query to refetch after authentication
      queryClient.invalidateQueries({ queryKey: queryKeys.user.me });
    },
  });
}
